import request from '@/utils/request'

/**
 * 获取websocket token
 * */
export function getWSToken(data) {
  return request({
    url: '/api/socket/get-client-token',
    method: 'post',
    data
  })
}

/**
 * 获取Agent Chat 频道订阅token
 * */
export function getWSSubscribeChatToken(data) {
  return request({
    url: '/api/socket/subscribe-chat-token',
    method: 'post',
    data
  })
}

/**
 * 获取Com Agent Chat 频道订阅token
 * */
export function getWSSubscribeComChatToken(data) {
  return request({
    url: '/api/socket/subscribe-com-chat-token',
    method: 'post',
    data
  })
}

/**
 * 获取订阅Com Agent chat 频道的管道
 * */
export function getWSComChatChannel(data) {
  return request({
    url: '/api/socket/get-com-chat-channel',
    method: 'post',
    data
  })
}


/**
 * 上报前端 WebSocket / 聊天实时链路诊断事件。
 * 诊断请求必须静默，避免网络故障时再弹出第二个错误提示。
 */
export function reportWSClientDiagnostic(data) {
  return request({
    url: '/api/socket/report-client-diagnostic',
    method: 'post',
    timeout: 3000,
    suppressErrorMessage: true,
    data
  })
}
